// BetaTech (2026-10-21, client request "një zemër diku për wishlist"): the wishlist ("Lista e dëshirave").
//
// Storage: localStorage "beta:wishlist" in the visitor's browser, for guests and signed-in customers alike
// (nothing is stored on the server). The value is a JSON array of { "handle": "<product handle>",
// "t": <time saved, ms> }, newest first, without duplicates, at most 100 items (saving a 101st drops the
// oldest). A corrupt or foreign value reads as an empty list; when localStorage cannot be used (blocked
// storage, some private modes, full quota) the list lives in memory for the current page only.
// A later sync to a customer metafield (e.g. customer.metafields.beta.wishlist, list of product
// references) would read / write the same array through an app proxy or the Customer Account API; the
// helpers below are the single place to change.
//
// Page parts (loaded by layout/theme.liquid for retail visitors; by sections/beta-wishlist.liquid itself
// for B2B buyers or with the setting off):
// - [data-beta-wishlist-toggle][data-handle]: the heart on the product page (snippets/beta-wishlist-button.liquid):
//   aria-pressed / .is-active follow the list, a click toggles, a polite status line announces the change;
// - [data-beta-wishlist-count]: the count badge of the header heart (snippets/beta-wishlist-link.liquid),
//   hidden at 0, "99+" above 99;
// - [data-beta-wishlist-page]: the wishlist page (sections/beta-wishlist.liquid): fetches every saved product's
//   card through the Section Rendering API (/products/<handle>?section_id=beta-wishlist-card), 4 requests at a
//   time, keeps the saved order, adds a remove button per card, drops products that answer 404.
// Every change is written at once, broadcast as the document event "beta:wishlist:change" and picked up by
// other tabs through the "storage" event.
// The pure list helpers (window.BetaWishlist.parse / add / remove / toggle / has / read / write) are
// unit-tested in tests/beta-wishlist.jxa.js; the DOM part below only runs in a browser.
window.BetaWishlist = window.BetaWishlist || (function () {
  var KEY = 'beta:wishlist';
  var MAX = 100;
  var memory = null; // the list while localStorage cannot be written

  // A product handle as Shopify prints it (product.handle): lowercase letters / digits / dashes, unicode
  // letters allowed; anything with spaces, slashes, quotes or URL syntax is refused.
  function cleanHandle(value) {
    if (typeof value !== 'string') return '';
    var handle = value.trim().toLowerCase();
    if (!handle || handle.length > 255 || /[\s\/\\?#"'<>&]/.test(handle)) return '';
    return handle;
  }

  // Stored value (JSON string, array or { items: [...] }) → clean list: [{ handle, t }], newest first.
  function parse(raw) {
    var data = raw;
    if (typeof raw === 'string') {
      try {
        data = JSON.parse(raw);
      } catch (error) {
        return [];
      }
    }
    if (data && !Array.isArray(data) && Array.isArray(data.items)) data = data.items;
    if (!Array.isArray(data)) return [];
    var seen = Object.create(null);
    var list = [];
    for (var i = 0; i < data.length && list.length < MAX; i++) {
      var item = data[i];
      var handle = cleanHandle(typeof item === 'string' ? item : item && item.handle);
      if (!handle || seen[handle]) continue;
      var time = item && typeof item === 'object' ? Number(item.t) : 0;
      seen[handle] = true;
      list.push({ handle: handle, t: isFinite(time) && time > 0 ? Math.round(time) : 0 });
    }
    return list;
  }

  function indexOf(list, handle) {
    for (var i = 0; i < list.length; i++) if (list[i].handle === handle) return i;
    return -1;
  }

  function has(list, handle) {
    handle = cleanHandle(handle);
    return !!handle && indexOf(parse(list), handle) !== -1;
  }

  // Returns a new list with the handle first (newest); unchanged if it is already saved or invalid.
  function add(list, handle, now) {
    var next = parse(list);
    handle = cleanHandle(handle);
    if (!handle || indexOf(next, handle) !== -1) return next;
    next.unshift({ handle: handle, t: typeof now === 'number' && now > 0 ? Math.round(now) : Date.now() });
    if (next.length > MAX) next.length = MAX; // the oldest goes
    return next;
  }

  function remove(list, handle) {
    handle = cleanHandle(handle);
    return parse(list).filter(function (item) {
      return item.handle !== handle;
    });
  }

  // { list, saved }: saved = the handle is in the list afterwards.
  function toggle(list, handle, now) {
    if (has(list, handle)) return { list: remove(list, handle), saved: false };
    var next = add(list, handle, now);
    return { list: next, saved: has(next, handle) };
  }

  function defaultStorage() {
    try {
      return typeof window !== 'undefined' && window.localStorage ? window.localStorage : null;
    } catch (error) {
      return null; // access itself can throw (blocked cookies / site data)
    }
  }

  // store (optional): an object with getItem / setItem / removeItem (tests); default localStorage.
  function read(store) {
    if (memory) return parse(memory);
    store = store || defaultStorage();
    if (!store) return [];
    try {
      return parse(store.getItem(KEY));
    } catch (error) {
      return [];
    }
  }

  // Returns true when the list was stored; false when it is only kept in memory for this page.
  function write(list, store) {
    var clean = parse(list);
    store = store || defaultStorage();
    try {
      if (!store) throw new Error('no storage');
      if (clean.length) store.setItem(KEY, JSON.stringify(clean));
      else store.removeItem(KEY);
      memory = null;
      return true;
    } catch (error) {
      memory = clean;
      return false;
    }
  }

  function resetMemory() {
    memory = null;
  }

  return {
    KEY: KEY,
    MAX: MAX,
    cleanHandle: cleanHandle,
    parse: parse,
    has: has,
    add: add,
    remove: remove,
    toggle: toggle,
    read: read,
    write: write,
    resetMemory: resetMemory
  };
})();

(function () {
  if (typeof document === 'undefined' || window.BetaWishlist.domReady) return;
  window.BetaWishlist.domReady = true;

  var W = window.BetaWishlist;
  var CHANGE_EVENT = 'beta:wishlist:change';
  var CONCURRENCY = 4;
  var pages = [];

  function each(selector, scope, fn) {
    var nodes = (scope || document).querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) fn(nodes[i]);
  }

  function handles(list) {
    return list.map(function (item) {
      return item.handle;
    });
  }

  function announce(element, text) {
    if (!element || !text) return;
    element.textContent = '';
    // a new text node in a later frame, so screen readers announce the same message twice in a row too
    window.requestAnimationFrame(function () {
      element.textContent = text;
    });
  }

  // Header counts and product-page hearts follow the stored list.
  function update() {
    var list = W.read();
    var count = list.length;
    each('[data-beta-wishlist-count]', document, function (badge) {
      badge.textContent = count > 99 ? '99+' : String(count);
      badge.hidden = count === 0;
    });
    each('[data-beta-wishlist-link]', document, function (link) {
      link.classList.toggle('has-items', count > 0);
    });
    each('[data-beta-wishlist-toggle]', document, function (button) {
      var saved = W.has(list, button.getAttribute('data-handle'));
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      button.classList.toggle('is-active', saved);
      var title = button.getAttribute(saved ? 'data-title-remove' : 'data-title-add');
      if (title) button.setAttribute('title', title);
      button.removeAttribute('data-pending');
    });
    return list;
  }

  function broadcast(list, handle, saved) {
    var detail = { handles: handles(list), handle: handle, saved: saved };
    try {
      document.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: detail }));
    } catch (error) {
      // very old browsers: no CustomEvent constructor; nothing listens there anyway
    }
  }

  // Product page heart (event delegation: also works for a section re-rendered in the theme editor)
  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest('[data-beta-wishlist-toggle]') : null;
    if (!button) return;
    event.preventDefault();
    var handle = button.getAttribute('data-handle');
    var result = W.toggle(W.read(), handle, Date.now());
    W.write(result.list);
    update();
    var status = button.parentNode ? button.parentNode.querySelector('[data-beta-wishlist-status]') : null;
    announce(status, button.getAttribute(result.saved ? 'data-status-added' : 'data-status-removed'));
    broadcast(result.list, W.cleanHandle(handle), result.saved);
  });

  // ---------- wishlist page ----------

  function readConfig(root) {
    var element = root.querySelector('script[data-beta-wishlist-config]');
    var cfg = {};
    try {
      cfg = JSON.parse(element ? element.textContent : '{}') || {};
    } catch (error) {
      cfg = {};
    }
    var base = typeof cfg.root === 'string' && cfg.root ? cfg.root : '/';
    if (base.charAt(base.length - 1) !== '/') base += '/';
    cfg.root = base;
    cfg.section = cfg.section || 'beta-wishlist-card';
    cfg.removeLabel = cfg.removeLabel || '[title]';
    return cfg;
  }

  function fetchCard(cfg, handle, signal) {
    var url = cfg.root + 'products/' + encodeURIComponent(handle) + '?section_id=' + encodeURIComponent(cfg.section);
    var options = { credentials: 'same-origin', headers: { Accept: 'text/html' } };
    if (signal) options.signal = signal;
    return fetch(url, options).then(function (response) {
      if (response.status === 404) return { missing: true };
      if (!response.ok) throw new Error('HTTP ' + response.status);
      return response.text().then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        return { card: doc.querySelector('[data-beta-wishlist-card]') };
      });
    });
  }

  function setupPage(root) {
    if (root.getAttribute('data-beta-wishlist-ready') === 'true') return;
    root.setAttribute('data-beta-wishlist-ready', 'true');

    var cfg = readConfig(root);
    var grid = root.querySelector('[data-beta-wishlist-grid]');
    var empty = root.querySelector('[data-beta-wishlist-empty]');
    var loading = root.querySelector('[data-beta-wishlist-loading]');
    var failed = root.querySelector('[data-beta-wishlist-error]');
    var status = root.querySelector('[data-beta-wishlist-status]');
    var heart = root.querySelector('template[data-beta-wishlist-heart]');
    var heading = root.querySelector('[data-beta-wishlist-heading]');
    if (!grid || !empty) return;
    var run = 0;
    var shownKey = '';
    var controller = null; // aborts the requests of a render that a newer one replaced

    function setHidden(element, hidden) {
      if (element) element.hidden = hidden;
    }

    function showEmpty() {
      grid.innerHTML = '';
      setHidden(grid, true);
      setHidden(loading, true);
      setHidden(failed, true);
      setHidden(empty, false);
    }

    // "Produktet nuk u ngarkuan": nothing could be shown although the list is not empty
    function showFailed() {
      setHidden(grid, true);
      setHidden(loading, true);
      setHidden(empty, true);
      setHidden(failed, false);
    }

    // a card the visitor can see now (slots of products still loading are hidden)
    function visibleItem() {
      return grid.querySelector('.beta-wishlist__item:not([hidden])');
    }

    // The visitor removed the last card on screen while others are still loading (or could not be
    // loaded): the focus waits on the page heading instead of falling back to <body>.
    var parked = false;
    function parkFocus() {
      if (!heading) return;
      heading.setAttribute('tabindex', '-1');
      heading.focus();
      parked = true;
    }

    function focusCta() {
      var cta = empty.querySelector('[data-beta-wishlist-cta]');
      if (cta) cta.focus();
    }

    function removeButton(handle, title) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'beta-wishlist__remove';
      button.setAttribute('data-beta-wishlist-remove', '');
      button.setAttribute('data-handle', handle);
      // split / join, not replace(): a title with "$&", "$$", "$`" or "$'" must be inserted as written
      button.setAttribute('aria-label', String(cfg.removeLabel).split('[title]').join(title));
      if (cfg.removeTitle) button.setAttribute('title', cfg.removeTitle);
      if (heart && heart.content) button.appendChild(document.importNode(heart.content, true));
      return button;
    }

    function render() {
      var list = W.read();
      var current = ++run;
      if (controller) controller.abort();
      controller = typeof AbortController === 'function' ? new AbortController() : null;
      var signal = controller ? controller.signal : undefined;
      shownKey = handles(list).join('\n');
      if (!list.length) {
        showEmpty();
        return;
      }
      setHidden(empty, true);
      setHidden(failed, true);
      setHidden(loading, false);
      grid.innerHTML = '';
      setHidden(grid, false);
      grid.setAttribute('aria-busy', 'true');

      var slots = list.map(function (item) {
        var slot = document.createElement('div');
        slot.className = 'grid-item beta-wishlist__item';
        slot.setAttribute('data-handle', item.handle);
        slot.hidden = true;
        grid.appendChild(slot);
        return slot;
      });
      var next = 0;
      var active = 0;
      var done = 0;
      var errors = 0;
      var missing = [];

      function finish() {
        if (current !== run) return;
        grid.removeAttribute('aria-busy');
        setHidden(loading, true);
        slots.forEach(function (slot) {
          if (slot.hidden && slot.parentNode) slot.parentNode.removeChild(slot);
        });
        if (missing.length) {
          var kept = W.read().filter(function (item) {
            return missing.indexOf(item.handle) === -1;
          });
          W.write(kept);
          shownKey = handles(kept).join('\n');
          update();
        }
        // decided by the cards on screen now, not by how many were loaded: the visitor may have removed
        // them while the others were still loading
        if (!visibleItem()) {
          if (errors) showFailed();
          else showEmpty();
          if (parked && document.activeElement === heading) {
            parked = false;
            if (!errors) focusCta();
          }
        }
      }

      function pump() {
        if (current !== run) return;
        while (active < CONCURRENCY && next < list.length) {
          (function (index) {
            var handle = list[index].handle;
            active++;
            fetchCard(cfg, handle, signal)
              .then(function (result) {
                if (current !== run) return;
                if (result.missing) {
                  missing.push(handle);
                  return;
                }
                if (!result.card) {
                  errors++;
                  return;
                }
                var slot = slots[index];
                var card = document.importNode(result.card, true);
                slot.appendChild(card);
                slot.appendChild(removeButton(handle, result.card.getAttribute('data-title') || handle));
                slot.hidden = false;
              })
              .catch(function () {
                if (current === run) errors++;
              })
              .then(function () {
                if (current !== run) return; // replaced by a newer render
                active--;
                done++;
                if (done === list.length) finish();
                else pump();
              });
          })(next++);
        }
      }

      pump();
    }

    grid.addEventListener('click', function (event) {
      var button = event.target && event.target.closest ? event.target.closest('[data-beta-wishlist-remove]') : null;
      if (!button) return;
      event.preventDefault();
      var handle = button.getAttribute('data-handle');
      var list = W.remove(W.read(), handle);
      W.write(list);
      shownKey = handles(list).join('\n');

      var item = button.closest('.beta-wishlist__item');
      var items = Array.prototype.slice.call(grid.querySelectorAll('.beta-wishlist__item:not([hidden])'));
      var position = items.indexOf(item);
      var target = items[position + 1] || items[position - 1] || null;
      if (item && item.parentNode) item.parentNode.removeChild(item);
      update();
      announce(status, cfg.removed);
      broadcast(list, handle, false);

      if (target) {
        var focusButton = target.querySelector('[data-beta-wishlist-remove]');
        if (focusButton) focusButton.focus();
      } else if (!visibleItem()) {
        if (grid.querySelector('.beta-wishlist__item')) {
          // other saved products are still loading: the loading line stays, finish() decides what follows
          parkFocus();
        } else if (!list.length) {
          showEmpty();
          focusCta();
        } else {
          // only products that could not be loaded are left in the list
          showFailed();
          parkFocus();
        }
      }
    });

    pages.push({
      refresh: function () {
        // another tab changed the list: re-render only if the saved handles differ from what is shown
        if (handles(W.read()).join('\n') !== shownKey) render();
      }
    });
    render();
  }

  function init(scope) {
    update();
    each('[data-beta-wishlist-page]', scope, setupPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // other tabs (the storage event fires only in the tabs that did not write)
  window.addEventListener('storage', function (event) {
    if (event.key !== null && event.key !== W.KEY) return;
    update();
    pages.forEach(function (page) {
      page.refresh();
    });
  });
  // back / forward cache: the list may have changed on another page
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    update();
    pages.forEach(function (page) {
      page.refresh();
    });
  });
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
